import { addSeconds, areIntervalsOverlapping } from 'date-fns'

import { ScheduleShift } from '../../@paco/entities/Shift/Shift'
import { getEndOfWorkDay, getStartOfWorkDay } from '../../@paco/helpers/date'

export default function doesShiftFallOnWorkDay(shift: ScheduleShift, day: Date): boolean {
    return areIntervalsOverlapping(
        {
            start: new Date(shift.period.start),
            end: addSeconds(new Date(shift.period.start), 1),
        },
        {
            start: getStartOfWorkDay(day),
            end: getEndOfWorkDay(day),
        },
    )
}
